import React, {Component} from 'react';

import { InputGroup, InputGroupText, Input } from 'reactstrap';

import './styles.css';


class SearchMOQ extends Component {
    constructor(props) {
        super(props)
        this.state = {
            item: '',
            vendor: '',
            filterByItem: '', 
            filterByVendor: ''

        }
    }

    handleItemChange = (e) => {
        let item = e.target.value;
        this.setState({item: item});
        this.props.itemSearch(item); 
    }


    handleVendorChange = (e) => {
        let vendor = e.target.value;
        this.setState({vendor: vendor});
        this.props.vendorSearch(vendor);
    }

    handleFilterItemChange = (e) => {
        let item = e.target.value;
        this.setState({filterByItem: item});
        this.props.filterItem(item);
    }

    handleFilterVendorChange = (e) => {
        let vendor = e.target.value;
        this.setState({filterByVendor: vendor});
        this.props.filterVendor(vendor);
        
    }

    keyPressedItem = (e) => {
        const key = e.key;   
        if(key === 'Enter') {
            if(this.state.vendor.length > 0) {
                this.props.triggerSearchItemAndVendor(this.state.item, this.state.vendor);
            } else {
                const trigger = true;
                this.props.triggerSearchItem(trigger);
            }    
        }
    }

    keyPressedVendor = (e) => {
        const key = e.key;
        if(key === 'Enter') {
            if(this.state.item.length > 0) {
                this.props.triggerSearchItemAndVendor(this.state.item, this.state.vendor);
            } else {
                const trigger = true;
                this.props.triggerSearchVendor(trigger);
            }
        }
    }

    render() {
        return (
            <div className="search-bar">
                <InputGroup className="input-group-container">
                    <InputGroupText addonType="prepend">
                        <InputGroupText >Item</InputGroupText>
                    </InputGroupText>
                    <Input  onChange={this.handleItemChange}  value={this.state.item} onKeyPress={this.keyPressedItem}/>
                </InputGroup>
                <InputGroup className="input-group-container">
                    <InputGroupText addonType="prepend">
                        <InputGroupText >Vendor</InputGroupText>
                    </InputGroupText>
                    <Input  onChange={this.handleVendorChange}  value={this.state.vendor} onKeyPress={this.keyPressedVendor}/>
                </InputGroup>
                <InputGroup className="input-group-container">
                    <InputGroupText addonType="prepend">
                        <InputGroupText >Filter by Item</InputGroupText>
                    </InputGroupText>
                    <Input  onChange={this.handleFilterItemChange}  value={this.state.filterByItem}/>
                </InputGroup>
                <InputGroup className="input-group-container">
                    <InputGroupText addonType="prepend">
                        <InputGroupText >Filter by Vendor</InputGroupText>
                    </InputGroupText>
                    <Input  onChange={this.handleFilterVendorChange}  value={this.state.filterByVendor}/>
                </InputGroup>
            </div>
        );
    }
    
}

export default SearchMOQ;